module.exports = __webpack_public_path__ + "media/images/cz500-782bf59032b6f8e26fa18b2f2ee59547.svg";